import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import warranty from 'public/static/images/vdp/warranty.svg';
import arrowRight from 'public/static/images/vdp/arrow-right-gray1.svg';

export default css`
  .warranty-promo {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    align-items: center;
    padding: 8px 12px;
    border-radius: 8px;
    text-decoration: none;
    border: 1px solid ${colors.G2};
    margin-top: 16px;
  }

  .warranty-promo:hover {
    text-decoration: none;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  }

  .warranty-promo:focus {
    text-decoration: none;
  }

  @media (min-width: ${screen.mdMin}) {
    .warranty-promo {
      padding: 12px 24px 14px 16px;
    }
  }

  .warranty-icon {
    height: 48px;
    width: 48px;
    background-size: cover;
    background-image: url(${warranty});
    margin-right: 12px;
  }

  @media (min-width: ${screen.mdMin}) {
    .warranty-icon {
      height: 70px;
      width: 70px;
      margin-right: 16px;
    }
  }

  .flex-container {
    display: flex;
    flex-direction: column;
  }

  .warranty-text {
    font-size: 18px;
    font-weight: 700;
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.mdMin}) {
    .warranty-text {
      font-size: 22px;
    }
  }

  .mobile {
    display: block;
  }

  .desktop {
    display: none;
  }

  @media (min-width: ${screen.mdMin}) {
    .mobile {
      display: none;
    }

    .desktop {
      display: block;
    }
  }

  .warranty-subtext {
    display: none;
  }

  @media (min-width: ${screen.mdMin}) {
    .warranty-subtext {
      display: block;
      font-weight: 400;
      font-size: 16px;
      letter-spacing: 0.31px;
      color: ${colors.BLACK};
    }
  }

  .arrow-right {
    margin-left: auto;
    height: 15px;
    width: 10px;
    background-size: cover;
    background-image: url(${arrowRight});
  }

  @media (min-width: ${screen.lgMin}) {
    .arrow-right {
      display: none;
    }
  }

  .see-rates-button {
    display: none;
  }

  @media (min-width: ${screen.lgMin}) {
    .see-rates-button {
      display: block;
      text-align: center;
      width: 116px;
      height: 44px;
      line-height: 40px;
      margin-left: auto;
      border-radius: 4px;
      background-color: ${colors.ALB1};
      color: white;
      font-weight: 600;
      font-size: 16px;
      letter-spacing: 0.21px;
    }

    .see-rates-button:hover {
      background-color: ${colors.ALB2};
    }
  }
`;
